export default __webpack_public_path__ + "static/media/icon-2.ae5515f5.png";